import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getTables, selectTables } from "../../redux/features/table/TableSlice";
import { useDispatch, useSelector } from "react-redux";
import { TbStatusChange } from "react-icons/tb";
import { FiX } from "react-icons/fi";
import { toast } from "react-toastify";
import {
  changeTable,
  getPendingOrders,
  RESETORDER,
  selectSuccessChangeTable,
} from "../../redux/features/order/OrderSlice";

const ChangeTable = ({ tableNo, orderId }) => {
  const [isOpenTable, setIsOpenTable] = useState(false);
  const [newTableNo, setNewTableNo] = useState(tableNo);
  const isSuccess = useSelector(selectSuccessChangeTable);

  const tables = useSelector(selectTables);
  const dispatch = useDispatch();

  const tableSelectOptions = tables.map((table) => ({
    value: table.tableNo,
    label: `${table.tableNo} (${table.tableStatus})`,
    isDisabled: table.tableStatus !== "vacant",
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "none",
      borderBottom: "1px solid #0D868C",
      borderRadius: "0px",
      boxShadow: "none",
      outline: "none",
      backgroundColor: "transparent",
      minHeight: "30px",
      padding: "none",
      textTransform: "capitalize",
      cursor: "pointer",
      "&:hover": {
        borderBottom: "1px solid #0D868C",
        boxShadow: "none",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 130,
      overflowY: "auto",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "0.9rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "0.9rem",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#AEE8EB"
        : state.isFocused
        ? "#E0F7FA"
        : "white",
      //   color: state.isSelected ? "white" : "#0D868C",
      color: state.isDisabled ? "#999" : "#000",
      padding: "4px",
      fontSize: "0.9rem",
      textTransform: "capitalize",
      cursor: state.isDisabled ? "not-allowed" : "default",
    }),
  };

  const changetable = async (e) => {
    e.preventDefault();
    if (newTableNo === tableNo) {
      toast.error("Order already has this table");
      return;
    }

    await dispatch(changeTable({ newTableNo, orderId }));
    dispatch(getPendingOrders());
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(RESETORDER());
      setIsOpenTable(false);
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    dispatch(getTables());
  }, [dispatch]);
  return (
    <div>
      <TbStatusChange
        onClick={() => setIsOpenTable(true)}
        className=" cursor-pointer"
      />
      {isOpenTable && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] sm:w-[450px] w-[90%] mx-auto p-8 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="md:text-[1.2rem] text-[1rem] font-bold text-[#0D868C]">
                Change Table
              </h1>
              <button type="button" onClick={() => setIsOpenTable(false)}>
                <FiX className="md:size-7 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={changetable}>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Table No
                </label>
                <Select
                  options={tableSelectOptions}
                  value={
                    tableSelectOptions.find(
                      (opt) => opt.value === newTableNo
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setNewTableNo(selectedOption?.value)
                  }
                  placeholder="Search Table"
                  styles={customStyles}
                  isSearchable
                  className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2"
                />
                {/* {errors.amountType && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.amountType}
                  </p>
                )} */}
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  Change Table
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangeTable;
